<div class="comment-main-container">
  <div class="flex justify-content-between align-items-start">
    <div class="text-sm font-bold flex align-items-center gap-2 mb-3">
      <p class="mt-2">Comments</p>
      @if(comments.length){
      <div
        class="mt-2 flex align-items-center justify-content-center bg-primary-700 text-white border-circle text-xs w-1rem h-1rem"
      >
        {{ comments.length }}
      </div>
      }
    </div>
  </div>
  <div class="comment-body-container">
    @for (comment of comments; track $index) {
    <div class="comment-message-body">
      <div class="bordcer-bottom-1 surface-border py-2">
        <div class="flex gap-2 align-items-center">
          <div class="comment-icon-container">
            <div
              class="comment-icon flex align-items-center justify-content-center border-circle surface-border font-semibold text-white"
              [style.background]="getBackground(comment.createdBy)"
            >
              @if (_auth.userByEmail[comment.createdBy]) { @if
              (comment.createdBy == _auth.userDetail().email ) {
              <span
                [style.color]="getTextColor(comment.createdBy)"
                class="avatarText"
              >
                Me
              </span>
              }@else {
              <span
                class="avatarText"
                [style.color]="getTextColor(comment.createdBy)"
              >
                {{ _auth.userByEmail[comment.createdBy].firstName.charAt(0)
                }}{{
                  _auth.userByEmail[comment.createdBy].lastName
                    ? _auth.userByEmail[comment.createdBy].lastName.charAt(0)
                    : ""
                }}
              </span>
              } }@else {
              <span
                class="avatarText"
                [style.color]="getTextColor(comment.createdBy)"
              >
                {{ comment.createdBy.charAt(0)
                }}{{ comment.createdBy.charAt(0) }}
              </span>
              }
            </div>
          </div>
          <div class="text-sm font-medium text-color">
            @if (_auth.userByEmail[comment.createdBy]) { @if (comment.createdBy
            == _auth.userDetail().email) {Me}@else {
            <span>
              {{ _auth.userByEmail[comment.createdBy].firstName + " "
              }}{{
                _auth.userByEmail[comment.createdBy].lastName
                  ? _auth.userByEmail[comment.createdBy].lastName
                  : ""
              }}
            </span>
            } }@else {
            <span>
              {{ comment.createdBy }}
            </span>
            }
          </div>
          <span class="text-xs text-500 text-right">{{
            comment.createdAt | timeAgo
          }}</span>
        </div>
        <div
          class="flex justify-content-between gap-2 align-items-baseline border-round"
        >
          <div
            class="comment-body-html text-xs white-space-normal"
            [innerHTML]="comment.body | sanitizer"
          ></div>
          <div class="">
            @if (comment.createdBy == _auth.userDetail().email) {
            <p-button
              (onClick)="deleteComment($event, comment, $index)"
              plain="true"
              text="true"
              class="deleteButton"
              styleClass="text-xs p-0 m-0"
              [disabled]="isDeleting && deletingIndex == $index"
            >
              @if (isDeleting && deletingIndex == $index) {
              <i
                class="pi pi-spin pi-spinner"
                style="font-size: small !important"
              ></i>
              }@else {
              <i class="pi pi-trash" style="font-size: small !important"></i>
              }
            </p-button>
            }
          </div>
        </div>
      </div>
    </div>
    }@empty {
    <div class="text-center my-3">No comments yet</div>
    }
  </div>
  <div class="surface-0 border-round p-2 border-1 surface-border">
    <app-editor
      [body]="body"
      [users]="usersNameAndEmail"
      (bodyChange)="onBodyChange($event)"
    ></app-editor>
    @if(body){
    <div class="flex justify-content-end mt-2">
      <p-button
        (onClick)="submitComment()"
        styleClass="text-xs h-2rem"
        [disabled]="isSubmitting"
      >
        @if (isSubmitting) { Adding comment..
        <i class="pi pi-spin pi-spinner text-lg ml-1"></i>
        }@else { Add comment }
      </p-button>
    </div>
    }
  </div>
</div>
<div class="flex gap-2">
  <p-confirmPopup>
    <ng-template pTemplate="content" let-message>
      <div
        class="flex flex-column min-w-25rem max-w-28rem border-bottom-1 surface-border"
      >
        <span
          class="text-lg text-left text-color p-2 mt-1 mx-0 mb-0 font-medium"
          >{{ message.header }}</span
        >
        <i
          class="pi pi-exclamation-circle text-center text-3xl text-red-500 px-5"
        ></i>
        <p class="text-center px-2">{{ message.message }}</p>
      </div>
    </ng-template>
  </p-confirmPopup>
</div>
